import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import {
  CmsConfig,
  I18nModule,
  provideDefaultConfig,
  UrlModule,
  ConfigModule,
} from '@spartacus/core'
import { NavBarLinksComponent } from './nav-bar-links.component'
import { MatMenuModule } from '@angular/material/menu'
import { MatIconModule } from '@angular/material/icon'
import { RoutingModule } from '../../routing/routing.module'
import { PlpModule } from '../plp/plp.module'
import { PlpMenuBarComponent } from '../plp/plp-menu-bar/plp-menu-bar.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { FormsModule } from '@angular/forms'
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    I18nModule,
    MatMenuModule,
    MatIconModule,
    FormsModule,
    NgSelectModule,
    PlpModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CategoryNavigationComponent: {
          component: NavBarLinksComponent,
        },
      },
    } as CmsConfig),
    RoutingModule,
  ],
  // declarations: [PlpMenuBarComponent],
  //  exports: [
  //   PlpModule
  //  ]
})
export class NavBarModule {}
